import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../components/CTAButton';
import { Gift, Sparkles } from 'lucide-react';
interface InclusionsSectionProps {
  onScrollToPurchase: () => void;
}
export function InclusionsSection({
  onScrollToPurchase
}: InclusionsSectionProps) {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/sz7ETRZkX1jLiNs1VjCRqN/KIT_DE_EVALUACIONES.png',
    title: 'Kit de Evaluaciones',
    desc: '+50 Evaluaciones listas para todos los años'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gbnpSzD4xqBkm96fSwF1Fw/PLANIFICACION.png',
    title: 'Planificación de Clases',
    desc: 'Clases para todo el año planificadas en base al contenido teórico del Manual'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/fTBj1qWxgFq7srjthWCJqz/ACTIVIDADES.png',
    title: '+500 Actividades Didácticas',
    desc: 'Actividades Didacticas para todos los años listas para usar en clase'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/3WTgcxNYJ46iq4j9YYr1Lj/DIAPOSITIVAS.png',
    title: 'Diapositivas Listas',
    desc: 'Diapositivas listas para presentar en el aula'
  }];
  return <section className="bg-gradient-to-b from-[#F4F4F2] to-white py-8 px-4 border-y border-[#E2DED6]" data-id="element-109">
      <div className="max-w-5xl mx-auto text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-6" data-id="element-111">
          <div className="inline-flex items-center gap-2 bg-[#4A7C59]/10 text-[#4A7C59] text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-3" data-id="element-112">
            <Gift size={14} data-id="element-113" />
            <span data-id="element-114">Oferta especial</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#424E60] uppercase mb-1" data-id="element-115">
            Manual Académico Historia
          </h2>
          <p className="text-lg md:text-xl text-[#4A7C59] font-bold" data-id="element-116">
            + 4 Bonos complementarios totalmente gratis
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8" data-id="element-117">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-white rounded-xl shadow-md border border-[#E2DED6]/60 overflow-hidden flex flex-col" data-id="element-118">
              <div className="overflow-hidden relative" data-id="element-119">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-cover" data-id="element-120" />
                <div className="absolute top-2 right-2 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm" data-id="element-121">
                  GRATIS
                </div>
              </div>
              <div className="p-3 flex flex-col flex-grow" data-id="element-122">
                <h4 className="font-bold text-[#424E60] text-xs md:text-sm leading-tight mb-1" data-id="element-123">
                  {bonus.title}
                </h4>
                <p className="text-[10px] md:text-xs text-[#586880] mb-2 leading-snug flex-grow" data-id="element-124">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-125">
                  <span className="text-red-400 line-through text-[12px]" data-id="element-126">
                    $34.999
                  </span>
                  <span className="md:text-sm text-[#4A7C59] font-bold text-[16px]" data-id="element-127">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-lg border border-[#E2DED6]/60 p-6 md:p-8 max-w-lg mx-auto mb-2" data-id="element-128">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-129">
            <Sparkles size={18} className="text-yellow-500" data-id="element-130" />
            <p className="text-sm md:text-base text-[#586880] font-bold uppercase" data-id="element-131">
              Todo el Combo Completo
            </p>
            <Sparkles size={18} className="text-yellow-500" data-id="element-132" />
          </div>
          <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-133">
            <span className="text-4xl md:text-5xl font-extrabold text-[#424E60] tracking-tight" data-id="element-134">
              $19.990
            </span>
            <span className="text-base md:text-lg text-[#586880] font-medium" data-id="element-135">
              ARS
            </span>
          </div>
          <CTAButton onClick={onScrollToPurchase} data-id="element-136">
            Acceder ahora a la colección completa
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}